export default __webpack_public_path__ + "static/one-step-assessment-e7f0982a5d59fdec14699860bd440050.jpg";